module.exports = __webpack_public_path__ + "img/farming-how-we-work-hero.a23d676b.jpg";